<template>
	<div class="header" :class="{'on':search,'hei':(path=='info'||path=='search')}">
		<div class="fixed">
			<div class="wrap">
				<div class="logo" @click="router_url('/index')"></div>
				<div class="search_flex" v-if="search">
					<img src="@/assets/img/search.png" class="search_img" alt="">
					<div class="input">
						<input type="text" class="text" v-model="keyword" @keyup.enter="handleEnter" :placeholder="$t('搜索...')" />
					</div>
					<i class="el-icon-close close" @click="search =! search"></i>
				</div>
				<div class="nav" v-if="!search">
					<div class="li" @click="router_url('/index')">{{$t('首页')}}</div>
					<div class="li" @click="router_url('/product')">{{$t('产品')}}</div>
					<div class="li" @click="router_url('/patent')">{{$t('专利')}}</div>
					<!-- <div class="li" @click="router_url('/news')">{{$t('新闻')}}</div> -->
					<div class="li" @click="router_url('/partner')">{{$t('合作伙伴')}}</div>
					<div class="li" @click="router_url('/contact')">{{$t('联系我们')}}</div>
				</div>
				<div class="search_img" v-if="!search" @click="search =! search"></div>
				<el-dropdown placement="bottom" v-if="!search" @command="click_command">
					<div class="language">{{language[$i18n.locale]}}</div>
					<el-dropdown-menu slot="dropdown":append-to-body="false">
						<el-dropdown-item :class="$i18n.locale==index?'onn':''" :command="index" v-for="(item,index) in language" :key="index">{{item}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<img src="@/assets/img/nav_img.png" v-if="!search" @click="nav =! nav" class="nav_img wap" alt="">
			</div>
		</div>
		<div class="wrap_nav" v-if="nav">
			<div class="wrap">
				<div class="logo" @click="router_url('/index')"></div>
				<i class="el-icon-close close" @click="nav =! nav"></i>
			</div>
			<div class="list">
				<div class="li" @click="router_url('/index'),nav=false">{{$t('首页')}}<i class="el-icon-arrow-right"></i></div>
				<div class="li" @click="router_url('/product'),nav=false">{{$t('产品')}}<i class="el-icon-arrow-right"></i></div>
				<div class="li" @click="router_url('/patent'),nav=false">{{$t('专利')}}<i class="el-icon-arrow-right"></i></div>
				<!-- <div class="li" @click="router_url('/news'),nav=false">{{$t('新闻')}}<i class="el-icon-arrow-right"></i></div> -->
				<div class="li" @click="router_url('/partner'),nav=false">{{$t('合作伙伴')}}<i class="el-icon-arrow-right"></i></div>
				<div class="li" @click="router_url('/contact'),nav=false">{{$t('联系我们')}}<i class="el-icon-arrow-right"></i></div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'header_html',
	data() {
		return {
			search:false,
			nav:false,
			path:'',
			keyword:'',
			language:{}
		}
	},
	watch: {
		'$route':{
			handler(val) {
				this.path = val.path.replace('/', '');
			},
			immediate: true,
			deep: true,
		}
	},
	mounted() {
		// var {keyword} = this.$route.query;
		// if(keyword){
		// 	this.keyword = keyword;
		// 	this.search = true;
		// }
		this.init();
	},
	methods: {
		init(){
			this.$get("front/languages",{}).then((res) => {
				var list = res.data;
				var language = {};
				for (var i = 0; i < list.length; i++) {
					language[list[i].code] = list[i].name;
				}
				this.language = language;
			})
		},
		click_command(lang){
			this.$i18n.locale = lang;
			localStorage.setItem('lang',lang);
		},
		handleEnter(){
			if(this.path=='search'){
				this.$emit("search",this.keyword);
				this.search = false;
			}else{
				this.router_url('/search?keyword='+this.keyword);
				this.search = false;
			}
		}
	}
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/header_html.vue